import { getActiveAccountId } from '@auw/api-client';
import { resetChatRuntimeForLogout } from './chatStore';
import { useUIStore } from './uiStore';
import { useUserStore } from './userStore';
import { activeTenantKey as tenantKey, activeTenantNamespacedKey as tenantNamespacedKey } from '@auw/tenant';

const WALLPAPER_META_KEY_PREFIX = tenantKey('wallpaper');
const WALLPAPER_IMG_KEY_PREFIX = tenantKey('wallpaper_img');
const LEGACY_WALLPAPER_META_KEY = tenantKey('wallpaper');
const LEGACY_WALLPAPER_IMG_KEY = tenantKey('wallpaper_img');
const WIDGET_STORAGE_KEY_PREFIX = tenantKey('widget_canvas');
const WIDGET_SCOPED_KEYS = [
  tenantNamespacedKey('widget', 'calendar-modal'),
  tenantNamespacedKey('widget', 'email-modal'),
  tenantNamespacedKey('widget', 'dm-modal'),
  tenantNamespacedKey('widget', 'agent-modal'),
  tenantNamespacedKey('widget', 'layout-meta'),
] as const;

function removeLocalStorageKey(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // storage access errors are non-fatal during auth reset
  }
}

function getScopedStorageKey(baseKey: string, accountId: string | null): string {
  return `${baseKey}:${accountId || 'anonymous'}`;
}

export function resetRuntimeSessionState(options?: {
  resetDarkMode?: boolean;
}): void {
  useUserStore.getState().clear();
  resetChatRuntimeForLogout();

  // 로그아웃/탈퇴 시 활성 계정이 먼저 비워지므로, 테마를 새 계정(익명)
  // 스코프 기준으로 재동기화한다 — 이전 유저의 테마가 다음 유저 화면에
  // 남는 누수를 막는다. (클라우드로 flush 하지 않는다.)
  const ui = useUIStore.getState();
  if (options?.resetDarkMode) {
    // 탈퇴 등 명시적 초기화: 기본값(다크)으로 강제.
    ui.applyThemeSnapshot(true, 0);
  }
  ui.syncDarkModeForActiveAccount();

  useUIStore.setState({
    wallpaper: null,
    wallpaperUpdatedAt: 0,
    wallpaperAccountId: null,
    wallpaperExplicit: false,
    settingsModalOpen: false,
    settingsModalRequest: null,
  });
}

export function clearWithdrawnAccountClientState(accountId: string | null = getActiveAccountId()): void {
  removeLocalStorageKey(getScopedStorageKey(WIDGET_STORAGE_KEY_PREFIX, accountId));
  WIDGET_SCOPED_KEYS.forEach((key) => {
    removeLocalStorageKey(getScopedStorageKey(key, accountId));
  });

  removeLocalStorageKey(getScopedStorageKey(WALLPAPER_META_KEY_PREFIX, accountId));
  removeLocalStorageKey(getScopedStorageKey(WALLPAPER_IMG_KEY_PREFIX, accountId));
  removeLocalStorageKey(LEGACY_WALLPAPER_META_KEY);
  removeLocalStorageKey(LEGACY_WALLPAPER_IMG_KEY);

  if (useUIStore.getState().wallpaperAccountId === accountId) {
    useUIStore.setState({
      wallpaper: null,
      wallpaperUpdatedAt: 0,
      wallpaperAccountId: null,
      wallpaperExplicit: false,
    });
  }
}
